import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../../components/ui/tooltip';

/**
 * Why a host codec refused the text typed into a grid cell editor (S4 review F, F2), shown next to the input while
 * the editor stays open. A portal tooltip, because the grid cell clips its overflow. Only editors with a host value
 * codec (Azure Table) render it; SQL cell editors never do.
 */
export function CellParseError({ error, children }: { error?: string; children: ReactElement }) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={!!error}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side="bottom" align="start" className="border border-destructive bg-background text-destructive" data-testid="editable-cell-error">
          {error}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
